import styled from 'styled-components';

export const StyledThankYou = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
`;

export const StyledThankYouMain = styled.div`
  color: ${({ theme }) => theme.selection};
  font-family: "NeueMachina";
  font-size: 4rem;
  font-weight: 700;
  text-align: center;
`;

export const StyledThankYouNote = styled.div`
  color: white;
  font-family: "BebasNeue";
  font-size: 2rem;
  text-align: center;
`;
